module.exports = __webpack_public_path__ + "images/0a31dea9f9f5b2c168bfd2819da99c8c70b70fd6bce48056bc1b12076b890c2a.svg";